<template>
  <v-card class="mb-3 v-card--hover" hover :ripple="false">
    <cloud-mining :item="item" @click.native="onclick()" />
    <cloud-mining-detail :item="item" v-if="$vuetify.breakpoint.smAndUp && showDetail" />
    <sensitivity-table :item="item" v-if="$vuetify.breakpoint.smAndUp && showDetail" />
  </v-card>
</template>

<script>
import CloudMining from "./CloudMining";
import CloudMiningDetail from "./CloudMiningDetail";

import SensitivityTable from "@/components/SensitivityTable";

export default {
  name: "CloudMiningCard",
  props: ["item", "idx"],
  components: { CloudMining, CloudMiningDetail, SensitivityTable },
  methods: {
    onclick() {
      if (this.$vuetify.breakpoint.xsOnly) {
        location.hash = `#/product?id=${this.item.id}&coin=${this.item.coin}`;
      } else {
        this.showDetail = !this.showDetail;
      }
    }
  },
  data() {
    return {
      showDetail: this.idx === 0
    };
  }
}
</script>

<style scoped>

</style>